class Accordion {
  constructor(container) {
    this.container = container;
    this.headings = container.querySelectorAll(":scope > li");

    this.init();
  }

  init() {
    this.headings.forEach((heading) => {
      const content = heading.querySelector(".bundle-tab-contents");

      // Set ARIA defaults
      heading.setAttribute("aria-expanded", "false");
      if (content) {
        content.setAttribute("aria-hidden", "true");
        content.style.display = "none";
      }

      // Click event
      heading.addEventListener("click", () => this.toggle(heading));

      // Keyboard support (Enter)
      heading.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          this.toggle(heading);
        }
      });
    });
  }

  toggle(heading) {
    const content = heading.querySelector(".bundle-tab-contents");
    const isExpanded = heading.getAttribute("aria-expanded") === "true";

    // Toggle state
    heading.setAttribute("aria-expanded", !isExpanded);
    if (content) {
      content.setAttribute("aria-hidden", isExpanded);
      content.style.display = isExpanded ? "none" : "block";
    }
  }
}

// Auto-init on page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bundle-tab-titles").forEach((accordion) => {
    new Accordion(accordion);
  });
});
